import './style.scoped.css';
import { Helmet } from 'react-helmet-async';
// import { Row } from 'react-bootstrap';
//import CookiesForm from '../../components/CookiesForm/CookiesForm';

interface ContentProps {
};
const DeklaracjaDostepnosci: React.FC<ContentProps> = ({}) => {
    return (
      <main className='content'>
        <Helmet>
          <title>Kontakt</title>
        </Helmet>
        {/* <CookiesForm/> */}
        <h1 id="a11y-deklaracja" className='header-contact'>Kontakt</h1>
        <div className='contact-list'>
          <div className='contact-item col-12'>
            <div className='col-lg-2 col-md-6'>
              <h3>Adress: </h3>
            </div>
            <h3 className='col-lg-10 col-md-6'>ul.Prószkowska 76, P3 006</h3>
          </div>
          <div className='contact-item col-12'>
            <div className='col-lg-2 col-md-6'>
              <h3>Facebook: </h3>
            </div>
            <div className='col-lg-10 col-md-6'>
              <h3><a href="https://www.facebook.com/TeamBitPO?locale=pl_PL" target="_blank" rel="noreferrer">TeamBit Politechnika Opolska</a></h3>
            </div>
          </div>
          <div className='contact-item col-12'>
            <div className='col-lg-2 col-md-6'>
              <h3>Instagram: </h3>
            </div>
            <div className='col-lg-10 col-md-6'>
              <h3><a href="https://www.instagram.com/teambit_po/" target="_blank" rel="noreferrer">teambit_po</a></h3>
            </div>
          </div>
          <div className='contact-item col-12'>
            <div className='col-lg-2 col-md-6'>
              <h3>Email: </h3>
            </div>
            <h3 className="col-lg-10 col-md-6">teambit@po.edu.pl</h3>
          </div>
        </div>
        

        <div className="grid">
          <div className="backg-w"></div>
          <div className="backg-b"></div>
          <div className="backg-w"></div>
          <div className="backg-w"></div>
          <div className="backg-b"></div>
          <div className="backg-w"></div>
          <div className="backg-b"></div>
          <div className="backg-w"></div>
          <div className="backg-w"></div>
          <div className="backg-w"></div>
          <div className="backg-b"></div>
          <div className="backg-w"></div>
          <div className="backg-w"></div>
          <div className="backg-b"></div>
          <div className="backg-w"></div>
          <div className="backg-w"></div>
          <div className="backg-b"></div>
          <div className="backg-w"></div>
          <div className="backg-b"></div>
          <div className="backg-w"></div>

          <div className="backg-b"></div>
          <div className="backg-w"></div>
          <div className="backg-b"></div>
          <div className="backg-w"></div>
          <div className="backg-b"></div>
          <div className="backg-b"></div>
          <div className="backg-w"></div>
          <div className="backg-b"></div>
          <div className="backg-w"></div>
          <div className="backg-b"></div>
          <div className="backg-b"></div>
          <div className="backg-b"></div>
          <div className="backg-b"></div>
          <div className="backg-w"></div>
          <div className="backg-b"></div>          
          <div className="backg-w"></div>
          <div className="backg-b"></div>
          <div className="backg-b"></div>
          <div className="backg-w"></div>
          <div className="backg-b"></div>
        </div>
      </main>
    );
}
export default DeklaracjaDostepnosci;